import {createContext} from 'react';
import {
    AuthUser,
    JWT
} from 'aws-amplify/auth';
import type {AuthStatus} from '@flexinet/auth-components';


type AuthContextType = {
    user: AuthUser | undefined,
    // Whether the session has been RESOLVED, which `user` alone cannot say:
    // `user` is undefined both while Amplify is still answering and once it
    // has answered "nobody". 'resolving' until the user and session lookups
    // settle, then 'authenticated' or 'anonymous'. FNP-1728.
    status: AuthStatus,
    idToken?: JWT | undefined,
    accessToken?: JWT | undefined,
    cognitoGroups?: string[] | undefined,
    role?: string | undefined,
}


// The default is 'resolving', never 'anonymous': outside the provider nothing
// has checked the session, so this context cannot claim nobody is signed in.
export const AuthContext = createContext<AuthContextType>({
                                                              user: {} as AuthUser,
                                                              status: 'resolving',
                                                          });

